import {useToast} from 'vue-toast-notification';

export class ToastUtil {
    static successMsg(message, duration = 5000) {
        this.toast({
            type: 'success',
            message: message,
            duration: duration
        });
    }

    static async error(err, duration = 5000) {
        this.errorMsg(typeof err === 'string' ? err : err?.response?.data?.message?.error || err?.response?.data?.message || err?.message || err?.errorMsg || 'Error Occurred', duration);
    }

    static errorMsg(message, duration = 5000) {
        this.toast({
            type: 'error',
            message: message,
            duration: duration
        });
    }

    static warningMsg(message, duration = 5000) {
        this.toast({
            type: 'warning',
            message: message,
            duration: duration
        });
    }

    static infoMsg(message, duration = 5000) {
        this.toast({
            type: 'info',
            message: message,
            duration: duration
        });
    }

    static toast(args) {
        const toast = useToast();

        toast.open({
            message: args.message,
            type: args.type,
            position: args.position || 'bottom-right',
            duration: args.duration !== undefined ? args.duration : 5000,
        });
    }
}